import { useTranslation } from 'react-i18next'
import { Dialog } from 'ui/src/components/Dialog/Dialog'
import { LargeDialog } from 'ui/src/components/Dialog/LargeDialog'
import { Text } from 'ui/src/components/Text/Text'
import { yStack } from 'ui/src/patterns/stack'
import { sprinkles } from 'ui/src/theme/sprinkles.css'
import { InfoButton } from '../priceCalculator/PurchaseForm/OfferPresenter/InfoButton/InfoButton'
import { AddonComparisonDialogBody } from './AddonComparisonDialogBody'

export function AddonComparisonCard({
  baseTermsVersion,
  addonTermsVersion,
}: {
  baseTermsVersion: string
  addonTermsVersion: string
}) {
  const { t } = useTranslation(['common', 'purchase-form'])
  return (
    <LargeDialog.Root>
      <Dialog.Trigger asChild>
        <InfoButton className={sprinkles({ marginTop: 'md' })}>
          <div className={yStack()}>
            <Text as="div" size="xs">
              {t('purchase-form:COMPARE_ADDON_DIALOG_TRIGGER')}
            </Text>
            <Text as="span" color="textSecondary" size="xs" balance={true}>
              {t('purchase-form:COMPARE_ADDON_DIALOG_TRIGGER_DESCRIPTION')}
            </Text>
          </div>
        </InfoButton>
      </Dialog.Trigger>
      <LargeDialog.Content>
        <LargeDialog.CloseIconButton aria-label={t('common:DIALOG_CLOSE')} />
        <AddonComparisonDialogBody baseTermsVersion={baseTermsVersion} addonTermsVersion={addonTermsVersion} />
      </LargeDialog.Content>
    </LargeDialog.Root>
  )
}
